interface StateMessageProps {
  variant: "loading" | "error" | "empty";
  title: string;
  detail?: string;
}

/** Full-width message block for loading / error / empty states. */
export function StateMessage({ variant, title, detail }: StateMessageProps) {
  return (
    <div className={`state-message state-message--${variant}`} role="status">
      <p className="state-message__title">{title}</p>
      {detail && <p className="state-message__detail">{detail}</p>}
    </div>
  );
}
